var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDugood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 298,
    viewBox: "0 0 254 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09216 0H64.9065C105.066 0 126.127 16.7858 126.127 49.7979C126.127 82.8101 105.074 99.5959 64.9065 99.5959H2.09216V0ZM79.4028 49.7936C79.4028 29.3494 72.7304 26.074 61.8732 26.074H46.5692V73.5176H61.8732C72.9925 73.5176 79.4028 70.2379 79.4028 49.7936Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.951 58.0531C237.951 87.1442 217.281 101.442 180.654 101.442C145.332 101.442 124.142 87.9448 124.142 58.4577V0H168.486V60.8034C168.486 71.1547 173.719 75.2177 184.318 75.2177C194.78 75.2177 200.147 71.5506 200.147 60.8034V0H237.956L237.951 58.0531Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7521 123.182C54.157 123.182 46.8315 128.95 46.8315 148.081C46.8315 168.788 54.5652 174.551 65.5383 174.551C76.5115 174.551 81.8907 170.096 81.8907 165.25V163.528H65.2763V145.197H121.264V197.879H93.7919L91.5707 184.644H90.3934C85.6673 193.424 73.2548 199.708 54.6812 199.708C19.3599 199.708 0 177.301 0 148.06C0 118.31 22.7713 96.2947 64.2279 96.2947C98.1099 96.2947 117.732 112.547 119.957 130.891L82.0196 140.609C81.4954 126.983 73.6501 123.182 64.7521 123.182Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.71 199.713C142.325 199.713 119.434 178.877 119.434 148.064C119.434 117.251 142.325 96.2991 184.71 96.2991C227.095 96.2991 250.119 117.268 250.119 148.064C250.119 178.859 227.095 199.713 184.71 199.713ZM184.71 172.851C196.353 172.851 202.893 166.558 202.893 148.081C202.893 129.341 196.353 123.182 184.71 123.182C173.067 123.182 166.527 129.341 166.527 148.081C166.527 166.558 173.067 172.851 184.71 172.851Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2763 298C22.8916 298 0 277.16 0 246.351C0 215.543 22.8916 194.591 65.2763 194.591C107.661 194.591 130.686 215.569 130.686 246.364C130.686 277.16 107.661 298 65.2763 298ZM65.2763 271.134C76.9197 271.134 83.4589 264.841 83.4589 246.364C83.4589 227.624 76.9197 221.465 65.2763 221.465C53.6328 221.465 47.0936 227.624 47.0936 246.364C47.0936 264.841 53.6328 271.134 65.2763 271.134Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.242 196.562H192.035C232.194 196.562 253.255 213.348 253.255 246.36C253.255 279.372 232.203 296.158 192.035 296.158H129.242V196.562ZM206.579 246.36C206.579 225.916 199.906 222.64 189.049 222.64H173.719V270.084H189.027C200.147 270.084 206.557 266.809 206.557 246.364L206.579 246.36Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.09216 0H64.9065C105.066 0 126.127 16.7858 126.127 49.7979C126.127 82.8101 105.074 99.5959 64.9065 99.5959H2.09216V0ZM79.4028 49.7936C79.4028 29.3494 72.7304 26.074 61.8732 26.074H46.5692V73.5176H61.8732C72.9925 73.5176 79.4028 70.2379 79.4028 49.7936Z",
    fill: "url(#paint0_linear_4032_15948)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.951 58.0531C237.951 87.1442 217.281 101.442 180.654 101.442C145.332 101.442 124.142 87.9448 124.142 58.4577V0H168.486V60.8034C168.486 71.1547 173.719 75.2177 184.318 75.2177C194.78 75.2177 200.147 71.5506 200.147 60.8034V0H237.956L237.951 58.0531Z",
    fill: "url(#paint1_linear_4032_15948)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7521 123.182C54.157 123.182 46.8315 128.95 46.8315 148.081C46.8315 168.788 54.5652 174.551 65.5383 174.551C76.5115 174.551 81.8907 170.096 81.8907 165.25V163.528H65.2763V145.197H121.264V197.879H93.7919L91.5707 184.644H90.3934C85.6673 193.424 73.2548 199.708 54.6812 199.708C19.3599 199.708 0 177.301 0 148.06C0 118.31 22.7713 96.2947 64.2279 96.2947C98.1099 96.2947 117.732 112.547 119.957 130.891L82.0196 140.609C81.4954 126.983 73.6501 123.182 64.7521 123.182Z",
    fill: "url(#paint2_linear_4032_15948)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.71 199.713C142.325 199.713 119.434 178.877 119.434 148.064C119.434 117.251 142.325 96.2991 184.71 96.2991C227.095 96.2991 250.119 117.268 250.119 148.064C250.119 178.859 227.095 199.713 184.71 199.713ZM184.71 172.851C196.353 172.851 202.893 166.558 202.893 148.081C202.893 129.341 196.353 123.182 184.71 123.182C173.067 123.182 166.527 129.341 166.527 148.081C166.527 166.558 173.067 172.851 184.71 172.851Z",
    fill: "url(#paint3_linear_4032_15948)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2763 298C22.8916 298 0 277.16 0 246.351C0 215.543 22.8916 194.591 65.2763 194.591C107.661 194.591 130.686 215.569 130.686 246.364C130.686 277.16 107.661 298 65.2763 298ZM65.2763 271.134C76.9197 271.134 83.4589 264.841 83.4589 246.364C83.4589 227.624 76.9197 221.465 65.2763 221.465C53.6328 221.465 47.0936 227.624 47.0936 246.364C47.0936 264.841 53.6328 271.134 65.2763 271.134Z",
    fill: "url(#paint4_linear_4032_15948)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M129.242 196.562H192.035C232.194 196.562 253.255 213.348 253.255 246.36C253.255 279.372 232.203 296.158 192.035 296.158H129.242V196.562ZM206.579 246.36C206.579 225.916 199.906 222.64 189.049 222.64H173.719V270.084H189.027C200.147 270.084 206.557 266.809 206.557 246.364L206.579 246.36Z",
    fill: "url(#paint5_linear_4032_15948)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4032_15948",
    x1: 128.817,
    y1: -40.1655,
    x2: 126.225,
    y2: 239.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4032_15948",
    x1: 128.817,
    y1: -40.1655,
    x2: 126.225,
    y2: 239.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4032_15948",
    x1: 128.817,
    y1: -40.1655,
    x2: 126.225,
    y2: 239.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4032_15948",
    x1: 128.817,
    y1: -40.1654,
    x2: 126.226,
    y2: 239.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4032_15948",
    x1: 128.817,
    y1: -40.1656,
    x2: 126.225,
    y2: 239.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4032_15948",
    x1: 128.817,
    y1: -40.1655,
    x2: 126.225,
    y2: 239.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFD756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#4DB864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#EF5F94"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDugood);
export default __webpack_public_path__ + "static/media/dugood.580f8c4185248aa0011ab3ccb8c2f03a.svg";
export { ForwardRef as ReactComponent };